import { z } from 'zod';

export const loginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(4),
  useLdapLogin: z.boolean(),
});

export type LoginSchema = z.infer<typeof loginSchema>;

export const loginDefaultValues = {
  email: '',
  password: '',
  useLdapLogin: true,
};
